var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 1249 c-3 -6 26 -43 67 -85 l74 -75 -45 3 c-35 2 -45 0 -45 -12 0 -20 150 -53 163 -36 14 18 -20 161 -38 161 -12 0 -14 -10 -12 -45 l3 -45 -73 73 c-41 39 -76 72 -80 72 -4 0 -10 -5 -14 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162 1188 l-73 -73 3 45 c2 35 0 45 -12 45 -18 0 -52 -143 -38 -161 13 -17 163 16 163 36 0 12 -10 14 -45 12 l-45 -3 74 75 c63 64 81 96 53 96 -4 0 -40 -33 -80 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 1174 c-32 -17 -43 -49 -35 -107 6 -46 52 -97 87 -97 35 0 81 51 87 97 8 59 -3 90 -37 108 -36 19 -67 19 -102 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 938 c-37 -8 -41 -11 -32 -28 15 -28 12 -117 -5 -150 -13 -25 -13 -29 2 -34 15 -6 32 8 33 27 0 18 68 47 110 47 42 0 110 -29 110 -47 1 -19 18 -33 33 -27 15 5 15 9 2 34 -17 33 -20 122 -5 150 9 16 4 20 -41 29 -59 13 -147 13 -207 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 930 c-63 -26 -71 -131 -14 -182 48 -43 97 -34 126 22 15 30 20 95 9 125 -8 19 -55 45 -81 44 -10 0 -28 -4 -40 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855 929 c-34 -19 -45 -41 -45 -86 0 -106 73 -155 141 -95 25 23 33 38 36 78 4 43 2 55 -18 78 -27 30 -83 43 -114 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575 735 c-48 -47 -21 -166 40 -181 64 -16 115 34 115 114 0 58 -33 92 -90 92 -30 0 -47 -6 -65 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 690 c-60 -13 -102 -37 -108 -63 -3 -12 -5 -65 -3 -117 l3 -95 32 -3 32 -3 3 83 c2 66 6 83 18 83 12 0 16 -17 18 -82 l3 -83 49 0 c48 0 49 1 56 35 8 43 60 91 109 101 39 7 40 9 20 44 -8 14 -14 39 -15 56 0 21 -6 34 -17 39 -30 11 -155 15 -200 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 692 c-32 -6 -36 -11 -41 -47 -3 -22 -10 -50 -17 -62 -16 -30 -16 -30 23 -37 49 -10 101 -58 109 -101 7 -34 8 -35 56 -35 l49 0 3 83 c2 65 6 82 18 82 12 0 16 -17 18 -83 l3 -83 32 3 32 3 3 95 c4 127 0 137 -53 161 -48 21 -175 32 -235 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 520 c-123 -15 -148 -43 -148 -169 0 -102 4 -111 46 -111 l34 0 0 81 c0 71 2 80 18 77 14 -3 17 -16 20 -81 l3 -77 89 0 89 0 3 77 c3 65 6 78 21 81 15 3 17 -6 17 -77 l0 -81 34 0 c42 0 46 9 46 111 0 120 -24 151 -123 164 -82 11 -93 12 -149 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 231 c-53 -11 -75 -20 -75 -31 0 -12 10 -14 45 -12 l45 3 -75 -75 c-59 -60 -72 -78 -62 -88 10 -10 28 3 88 62 l75 75 -3 -45 c-2 -35 0 -45 12 -45 20 0 53 150 36 163 -6 5 -42 2 -86 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042 236 c-14 -18 20 -161 38 -161 12 0 14 10 12 45 l-3 45 75 -75 c60 -59 78 -72 88 -62 10 10 -3 28 -62 88 l-75 75 45 -3 c35 -2 45 0 45 12 0 20 -150 53 -163 36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingPoint);
export default __webpack_public_path__ + "static/media/meeting_point.4398dedff88b42b2181c17f0154fa5b6.svg";
export { ForwardRef as ReactComponent };